module.exports = __webpack_public_path__ + "img/card01.e17520d6.png";